import React, { useState } from "react";

import styles from "../../assets/styles/_hairCheck.module.scss";
import StartCheck from "./start";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";

const HairCheckComponent = () => {
  const [step, setStep] = useState(0);
  const [type, setType] = useState("");
  const [currentProduct, setCurrentProduct] = useState({});

  return (
    <div className={styles.hairCheckWrap}>
      <div
        className={`${styles.mask} ${step === 1 && styles.mask1} ${step === 2 && styles.mask1
          } ${step === 3 &&
          (type === "pink" ? styles.maskPink : styles.maskBlue)
          }`}
      ></div>
      <div className={`${styles.content} ${step === 0 || step === 3 ? styles.contentStart : ""}`}>
        {step === 0 && <StartCheck setStep={setStep} />}
        {step === 1 && <Step1 setStep={setStep} setType={setType} />}
        {step === 2 && (
          <Step2 type={type} setStep={setStep} setCurrentProduct={setCurrentProduct} />
        )}
        {(step === 1 || step === 2) && (
          <div className={styles.dots}>
            <div className={`${styles.dot} ${step === 1 && styles.acitvePink}`} onClick={() => {
              if (step > 1) {
                setStep(1);
              }
            }}>
              Q1
            </div>
            <div className={styles.line}></div>
            <div className={`${styles.dot} ${step === 2 && styles.acitveBlue}`} onClick={() => {
              if (step > 2) {
                setStep(2);
              }
            }}>
              Q2
            </div>
            <div className={styles.line}></div>
            <div className={styles.dot}>
              結果
            </div>
          </div>
        )}
        {step === 3 && <Step3 type={type} product={currentProduct} setStep={setStep} />}
      </div>
    </div>
  );
};

export default HairCheckComponent;
